import AppConstants from 'constants/AppConstants';

export interface State {
  quickActionsAvailable: boolean;
  mobileQuickActionsAvailable: boolean;
  showActionsModal: boolean;
}

export const initialState: State = {
  quickActionsAvailable: false,
  mobileQuickActionsAvailable: false,
  showActionsModal: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.RESERVATIONS_SET_QUICKACTIONS_AVAILABLE: {
      return {
        ...state,
        quickActionsAvailable: payload,
      };
    }
    case AppConstants.RESERVATIONS_SET_MOBILE_QUICKACTIONS_AVAILABLE: {
      return {
        ...state,
        mobileQuickActionsAvailable: payload,
      };
    }
    case AppConstants.RESERVATIONS_SET_SHOW_ACTIONS_MODAL:
      return {
        ...state,
        showActionsModal: payload,
      };
    default:
      return state;
  }
}
